import { React, useEffect } from "react";
import PageHeader from "../components/headers/PageHeader";
import Banner from "../components/banner/Banner";
import WhatsappBanner from "../components/banner/WhatsappBanner";
import TwoLineTitle from "../components/titles/TwoLineTitle";
import WebProjectCard from "../components/cards/WebProjectCard";

const UIUXDesign = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const uiux = [
    {
      name: "Smart Security App",
      category: "Mobile UI/UX",
      image: "assests/images/portfolio/uiux/lockit-m-ui.jpg",
      readmore:
        "https://www.figma.com/proto/QpSHAbXvwyoT33KRK8QX3W/lockit-mobile-app?page-id=0%3A1&type=design&node-id=3-95&viewport=368%2C76%2C0.2&t=mLk7r991OODmKRLl-1&scaling=scale-down&mode=design",
    },
    {
      name: "Auction Site | BidWiz 2.0",
      category: "Web UI/UX",
      image: "assests/images/portfolio/uiux/bidwiz-ui.jpg",
      readmore:
        "https://www.figma.com/file/nqkGDl3qmf7NwdFWVF0bq0/BidWiz-2.0?type=design&node-id=1%3A2&mode=design&t=mkpI1ivXboFlqNiJ-1",
    },
    {
      name: "Calculator App",
      category: "Mobile UI/UX",
      image: "assests/images/portfolio/uiux/cal-1-1.jpg",
      readmore:
        "https://www.figma.com/file/5gD7p5YLk0BKYzaeb7IL77/Calculator?type=design&node-id=0%3A1&mode=design&t=wcorGSeVycVgsYre-1",
    },
    {
      name: "App Launching Website",
      category: "Web UI/UX",
      image: "assests/images/portfolio/uiux/lockit-uiux.jpg",
      readmore:
        "https://www.figma.com/file/ThbrYxlSDaR8MKnrUtSdzh/Lockit-Web?type=design&node-id=1%3A11&mode=design&t=3ACp0dQvi3I1A6la-1",
    },
  ];

  return (
    <div>
      <PageHeader heading="UI/UX Design" />
      <div className="flex justify-center pt-8">
        <Banner
          url="contact"
          text="Get More Details"
          btn="Contact Me"
          subtext="I'm always open to discussing product design work or partnerships."
        />
      </div>

      <TwoLineTitle
        des="From designing to development, these are some skills I have been working on for the past couple of years."
        main="UI/UX Design"
      />

      <div className="w-full flex flex-col gap-8 px-4 md:px-8 py-4">
        {uiux.map((item, i) => (
          <WebProjectCard
            key={i}
            name={item.name}
            category={item.category}
            image={item.image}
            readmore={item.readmore}
            reverse={i % 2 !== 0}
          />
        ))}
      </div>

      <div className="flex justify-center py-8">
        <WhatsappBanner />
      </div>
    </div>
  );
};

export default UIUXDesign;
